import _regeneratorRuntime from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createClass";
import Signature from "./Signature";
import Policy from "./Policy";
import { dateISOString, xAmzDate, dateYMD } from "./Date";
import { throwError } from './ErrorThrower';

var S3FileUpload =
/*#__PURE__*/
function () {
  function S3FileUpload() {
    _classCallCheck(this, S3FileUpload);
  }

  _createClass(S3FileUpload, null, [{
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(file, config) {
        var fd, key, url, params, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Error Thrower :x:
                throwError(config, file);
                fd = new FormData();
                key = "".concat(config.dirName ? config.dirName + "/" : "").concat(file.name);
                url = "https://".concat(config.bucketName, ".s3.amazonaws.com/");
                fd.append("key", key);
                fd.append("acl", "public-read");
                fd.append("Content-Type", file.type);
                fd.append("x-amz-meta-uuid", "14365123651274");
                fd.append("x-amz-server-side-encryption", "AES256");
                fd.append("X-Amz-Credential", "".concat(config.accessKeyId, "/").concat(dateYMD, "/").concat(config.region, "/s3/aws4_request"));
                fd.append("X-Amz-Algorithm", "AWS4-HMAC-SHA256");
                fd.append("X-Amz-Date", xAmzDate);
                fd.append("x-amz-meta-tag", "");
                fd.append("Policy", Policy.getPolicy(config));
                fd.append("X-Amz-Signature", Signature.getSignature(config, dateYMD, Policy.getPolicy(config)));
                fd.append("file", file);
                params = {
                  method: "post",
                  headers: {
                    fd: fd
                  },
                  body: fd
                };
                _context.next = 19;
                return fetch(url, params);

              case 19:
                data = _context.sent;

                if (data.ok) {
                  _context.next = 22;
                  break;
                }

                return _context.abrupt("return", Promise.reject(data));

              case 22:
                return _context.abrupt("return", Promise.resolve({
                  bucket: config.bucketName,
                  key: "".concat(config.dirName ? config.dirName + "/" : "").concat(file.name),
                  location: "".concat(url).concat(config.dirName ? config.dirName + "/" : "").concat(file.name),
                  result: data
                }));

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function uploadFile(_x, _x2) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "deleteFile",
    value: function () {
      var _deleteFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(fileName, config) {
        var fd, url, params, deleteResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fd = new FormData();
                url = "https://".concat(config.bucketName, ".s3-").concat(config.region, ".amazonaws.com/").concat(config.dirName ? config.dirName + "/" : "").concat(fileName);
                fd.append("Date", xAmzDate);
                fd.append("X-Amz-Date", xAmzDate);
                fd.append("Authorization", Signature.getSignature(config, dateYMD, Policy.getPolicy(config)));
                fd.append("Content-Type", "text/plain");
                params = {
                  method: "delete",
                  headers: {
                    fd: fd
                  }
                };
                _context2.next = 9;
                return fetch(url, params);

              case 9:
                deleteResult = _context2.sent;

                if (deleteResult.ok) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt("return", Promise.reject(deleteResult));

              case 12:
                return _context2.abrupt("return", Promise.resolve({
                  ok: deleteResult.ok,
                  status: deleteResult.status,
                  message: "File Deleted",
                  fileName: fileName
                }));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function deleteFile(_x3, _x4) {
        return _deleteFile.apply(this, arguments);
      }

      return deleteFile;
    }()
  }]);

  return S3FileUpload;
}();

var uploadFile = S3FileUpload.uploadFile,
    deleteFile = S3FileUpload.deleteFile;
export { uploadFile, deleteFile };
export default S3FileUpload;